/* c8 ignore start */
import { mspRoutes } from "./routes";

import { NAV_ITEMS_MODE } from "@/constants";

import { MSP_NAV_ITEMS, CUSTOMER_NAV_ITEMS } from "./constants";

const PhishingSimulationsModule = ({ router, registerNavItems }) => {
  // Routes
  router.addRoute(mspRoutes);

  // Nav Items
  registerNavItems(NAV_ITEMS_MODE.MSP, MSP_NAV_ITEMS);
  registerNavItems(NAV_ITEMS_MODE.CUSTOMER_ADMIN, CUSTOMER_NAV_ITEMS);
};

export { PhishingSimulationsModule };

export default {};
/* c8 ignore end */
